module.exports = __webpack_public_path__ + "img/14-1_03.ee5955f5.jpg";